/* eslint-disable object-curly-newline */
import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { get } from 'rf-lib';

const Button = styled.button`
  ${props =>
    props.disabled
      ? css`
      color: lightgrey;
      cursor: default;
      `
      : css`
      color: white;
      cursor: pointer;
    `};
  font-size: ${get('fontTextSm')};
  text-decoration: none;
  margin: 1px;
  border: none;
  padding: ${get('spacingXs')};
  border-radius: ${get('spacingXs')};
  text-align: center;
  background: ${get('colorButton')};
`;

const ButtonWrapper = ({ title, onClick, ...props }) =>
  (
    <Button onClick={onClick} {...props}>
      {title}
    </Button>
  );

ButtonWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default ButtonWrapper;
